import type { TBidStatus } from '~/types/b2b'

const BID_STATUS_CLASSES: Record<TBidStatus, string> = {
  pending: 'bg-yellow-100 text-yellow-700',
  accepted: 'bg-green-100 text-green-700',
  rejected: 'bg-gray-100 text-gray-600',
}

const BID_STATUS_FALLBACK_CLASS = 'bg-gray-100 text-gray-600'

export const getBidStatusClass = (status: TBidStatus): string => BID_STATUS_CLASSES[status] ?? BID_STATUS_FALLBACK_CLASS
